import React from 'react';
import { Box, Heading, Icon, Text, VStack, Wrap } from '@chakra-ui/react';

const EmptyStateCard = ({
    icon,
    title,
    description,
    hint,
    children,
    bg = 'white',
    borderColor = 'gray.200',
    titleColor = 'gray.700',
    descriptionColor = 'gray.600',
    hintColor = 'gray.500',
    iconColor = 'gray.400',
    maxW = '2xl',
}) => {
    return (
        <Box
            w="full"
            maxW={maxW}
            mx="auto"
            bg={bg}
            borderRadius="xl"
            boxShadow="sm"
            borderWidth="1px"
            borderColor={borderColor}
            px={{ base: 6, md: 8 }}
            py={{ base: 8, md: 10 }}
        >
            <VStack spacing={4} align="center" textAlign="center">
                {icon && (
                    <Box
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                        w={14}
                        h={14}
                        borderRadius="full"
                        bg="blackAlpha.50"
                    >
                        <Icon as={icon} boxSize={7} color={iconColor} />
                    </Box>
                )}

                <VStack spacing={2} maxW="xl">
                    <Heading as="h3" size="md" color={titleColor}>
                        {title}
                    </Heading>

                    {description && (
                        <Text color={descriptionColor}>
                            {description}
                        </Text>
                    )}

                    {hint && (
                        <Text fontSize="sm" color={hintColor}>
                            {hint}
                        </Text>
                    )}
                </VStack>

                {children ? (
                    <Wrap justify="center" spacing={3}>
                        {children}
                    </Wrap>
                ) : null}
            </VStack>
        </Box>
    );
};

export default EmptyStateCard;
